import * as m from "mithril";
import * as dayjs from 'dayjs';
import { TripDTO, WayPointScheduleDTO } from "../apiclient/ApiDtos";
import { MessageProvider } from "../context/AppMessages";
import './TripItineraryView.scss';
import { getIntlStringValue } from "../helpers/StringHelpers";


function timelineNode(wayPoint:WayPointScheduleDTO, messageProvider:MessageProvider, currLang:string, isInSubTrip:boolean, isEstimated:boolean = false) { 
  return m("li", {
    class: (isInSubTrip)? 'active':'inactive'
  },
    m("div.d-flex", [
      m("div.flex-grow-1", [
        m("div", {
          "class" : (isInSubTrip)? '':'text-muted'
        }, getIntlStringValue(wayPoint.location.name, currLang)),
        (isInSubTrip && wayPoint.gateName)?
        m("small.text-muted", getIntlStringValue(wayPoint.gateName, currLang)) : null
      ]),
      m("div", {
        "class" : (isInSubTrip)? '':'text-muted'
      }, [
        (isEstimated)? m("span.mx-2", "(" + messageProvider.get("trip.estimated") + ") ") : null,
        dayjs(wayPoint.scheduledAt).format("hh:mm A, MMM D")
      ])
    ])
  );
}

export default function TripDetailsView(): m.Component<{
  messageProvider: MessageProvider,
  trip: TripDTO,
}> {
  return {

    view(vnode) {
      let trip = vnode.attrs.trip;
      let messageProvider = vnode.attrs.messageProvider;
      let currLang = messageProvider.getCurrentLang();

      return m("div", [                
        m("ul.timeline", [       
          (!trip.isDepartingFromOrigin)?   
          timelineNode(trip.origin, messageProvider, currLang, false) : null, 
          timelineNode(trip.departure, messageProvider, currLang, true), 
          timelineNode(trip.arrival, messageProvider, currLang, true, true)
        ]),
        /*
        m("div.mb-3", [
          m("div.text-muted", messageProvider.get("trip.route")),
          m("div.mt-1", m("small", getIntlStringValue(trip.fullRouteName, currLang)))
        ]),*/
      ])
    }
  }
}